if (!customElements.get('product-size-options')) {
  customElements.define(
    'product-size-options',
    class ProductSizeOptions extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.colorOptionIndex = Number.parseInt(this.getAttribute('color-option-index'), 10);
        this.form = document.getElementById(this.getAttribute('form-id'));
        this.currentOption = this.querySelector('[data-current-size-option]');

        this.links = Array.from(this.querySelectorAll('[data-size-option]')).map((link) => ({
          element: link,
          variants: this.parseJson(link.querySelector('[data-size-variants]'), []),
        }));

        const initialVariant = this.parseJson(this.querySelector('[data-current-variant]'));

        if (initialVariant) {
          this.updateLinks(initialVariant);
        }

        this.form?.addEventListener(
          'variant:change',
          (event) => {
            if (event.detail?.variant) {
              this.updateLinks(event.detail.variant);
            }
          },
          { signal: this.abortController.signal },
        );
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      parseJson(element, fallback = null) {
        if (!element) return fallback;

        try {
          return JSON.parse(element.textContent);
        } catch (error) {
          console.warn('Could not parse linked product size data.', error);
          return fallback;
        }
      }

      normalize(value) {
        return String(value || '').trim().toLocaleLowerCase();
      }

      updateLinks(currentVariant) {
        const currentColor = this.colorOptionIndex >= 0
          ? this.normalize(currentVariant.options?.[this.colorOptionIndex])
          : '';

        this.setAvailability(this.currentOption, !currentVariant.available);

        for (const link of this.links) {
          const matchingVariant = currentColor
            ? link.variants.find((variant) => this.normalize(variant.color) === currentColor)
            : null;
          const targetVariant = matchingVariant
            || link.variants.find((variant) => variant.available)
            || link.variants[0];

          if (!targetVariant) continue;

          const targetUrl = new URL(link.element.dataset.productUrl, window.location.origin);
          targetUrl.searchParams.set('variant', targetVariant.id);
          link.element.href = `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
          this.setAvailability(link.element, !targetVariant.available);
        }
      }

      setAvailability(element, soldOut) {
        if (!element) return;

        const soldOutLabel = element.querySelector('[data-sold-out-label]');
        const label = element.dataset.label || '';

        element.classList.toggle('is-sold-out', soldOut);
        soldOutLabel?.toggleAttribute('hidden', !soldOut);

        if (element.matches('a')) {
          element.setAttribute('aria-label', soldOut ? `${label} — ${soldOutLabel?.textContent.trim()}` : label);
        }
      }
    },
  );
}
